<template>
	<div>
		<action-sidebar
			:title="title"
			:value="value"
			@close-modal="closeModal"
		>
			<app-table
				class="mt-5 is-not-selectable contend-devices"
				name="users"
				selectable
				:check-all="checkAll"
				:columns="columns"
				:rows="rows"
				:current-page="currentPage"
				:last-page="lastPage"
				@on-page="changeDevicePage"
				@on-selected-all="allIsSelected"
				@row-is-selected="rowIsSelected"
			>
				<template slot="rows" slot-scope="props">
					<td
						class="is-not-selectable"
						v-show="showRow(columns, 1)"
					>
						{{ props.row.id }}
					</td>
					<td v-show="showRow(columns, 2)">
						{{ props.row.deviceName }}
					</td>
					<td v-show="showRow(columns, 3)">
						{{ props.row.dateLastAccess }}
					</td>
				</template>
			</app-table>
			<section class="modal-filter-footer">
			<modal-sidebar-button
				:isLoading="isBotonActivate"
				@accept-button-clicked="saveProcess"
				@cancel-button-clicked="closeModal"
			></modal-sidebar-button>
		</section>
		</action-sidebar>
	</div>
</template>

<script>
	import actionSidebar from '@/components/shared/action-sidebar';
	import appTooltipButton from '@/components/shared/app-tooltip-button';

	function changeDevicePage(page) {
		this.$emit('change-device-page', page);
	}

	function closeModal() {
		this.checkAll = false;
		this.dataSelected = [];
		this.$emit('toggle-devices');
	}

	function allIsSelected(checked) {
		this.checkAll = checked;
		this.rows = this.selectIsRow(this.rows, 'isSelected', false, checked);
		this.setDataSelected();
	}

	function rowIsSelected(row) {
		this.rows = this.selectIsRow(this.rows, 'isSelected', row);
		this.checkAll = this.every(this.rows);
		this.setDataSelected(row);
	}

	function setDataSelected(row) {
		if (!row) {
			if (this.checkAll) {
				this.rows.forEach((rowData) => {
					const index = this.dataSelected.findIndex(d => d.id === rowData.id);
					if (index < 0) {
						this.dataSelected.push(rowData);
					}
				});
			} else {
				this.rows.forEach((rowData) => {
					const index = this.dataSelected.findIndex(d => d.id === rowData.id);
					if (index >= 0) {
						this.dataSelected.splice(index, 1);
					}
				});
			}
		} else {
			const index = this.dataSelected.findIndex(d => d.id === row.id);
			if (index < 0) {
				this.dataSelected.push(row);
			} else {
				this.dataSelected.splice(index, 1);
			}
		}
	}

	function changeDevices() {
		this.rows = this.devices;
		this.checkAll = false;
	}

	function isBotonActivate() {
		return !this.dataSelected.length > 0 || this.isLoading;
	}

	function deviceDelete() {
		this.$emit('device-delete', 'devices');
	}

	async function saveProcess() {
		try {
			this.isLoading = true;
			const ids = this.dataSelected.map(d => d.id);
			const body = {
				devices: ids,
			};
			await this.$http.delete('users/devices', { data: body });
			this.showNotification('Dispositivos eliminados correctamente.');
			this.isLoading = false;
			this.closeModal();
			this.$emit('refresh-data');
		} catch (error) {
			this.showError();
			this.isLoading = false;
			this.closeModal();
		}
	}

	function data() {
		return {
			checkAll: false,
			isLoading: false,
			columns: [
				{ id: 1, name: 'ID', checked: true, visible: true },
				{ id: 2, name: 'Nombre', checked: true, visible: true },
				{ id: 3, name: 'Último Acceso', checked: true, visible: true },
			],
			rows: [],
			dataSelected: [],
		};
	}

	export default {
		name: 'devices',
		components: {
			actionSidebar,
			appTooltipButton,
		},
		data,
		methods: {
			closeModal,
			deviceDelete,
			allIsSelected,
			rowIsSelected,
			setDataSelected,
			saveProcess,
			changeDevicePage,
		},
		computed: {
			title() {
				return 'Dispositivos';
			},
			isBotonActivate,
		},
		props: {
			value: {
				type: Boolean,
			},
			devices: {
				type: Array,
				default: () => [],
			},
			lastPage: {
				type: Number,
				default: 0,
			},
			currentPage: {
				type: Number,
				default: 0,
			},
		},
		watch: {
			devices: changeDevices,
		},
	};
</script>

<style lang="scss" scoped>
	.contend-devices {
		padding: 0 10px 0 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/devices/devices.vue